// extracted by mini-css-extract-plugin
module.exports = {"affiliateBase":"styles_affiliateBase__Fpqqd"};